import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 61,
	height: 77,
	viewBox: "0 0 61 77",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .992705,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.48534 0.301758H37.3731L60.2354 23.1641V69.8605C60.2605 73.3283 57.4694 76.1595 54.0016 76.1846C53.9715 76.1846 53.9415 76.1846 53.9114 76.1846H6.48821C3.02044 76.2111 0.187795 73.4214 0.1613 69.9536C0.1613 69.9228 0.1613 69.8913 0.1613 69.8605V6.6258C0.136239 3.15803 2.92736 0.326819 6.39512 0.301758C6.4252 0.301758 6.45527 0.301758 6.48534 0.301758Z",
				fill: "#E6ECF1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.6167 0.301758L60.4798 23.1648H37.6167V0.301758Z",
				fill: "#D5DEE7"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.45839 18.7847H22.5367C22.9298 18.8076 23.2442 19.1219 23.2671 19.515V21.9467C23.2442 22.3398 22.9298 22.6541 22.5367 22.677H7.45839C7.06528 22.6541 6.75094 22.3398 6.72803 21.9467V19.515C6.75094 19.1219 7.06528 18.8076 7.45839 18.7847ZM7.45839 53.564H29.5911C29.9842 53.587 30.2978 53.9013 30.3208 54.2944V56.7261C30.2978 57.1192 29.9842 57.4335 29.5911 57.4564H7.45839C7.06528 57.4335 6.75094 57.1192 6.72803 56.7261V54.2944C6.75094 53.9013 7.06528 53.587 7.45839 53.564ZM7.45839 45.296H53.1817C53.5748 45.3189 53.8891 45.6325 53.912 46.0256V48.4573C53.8891 48.8504 53.5748 49.1647 53.1817 49.1876H7.45839C7.06528 49.1647 6.75094 48.8504 6.72803 48.4573V46.0242C6.75166 45.6318 7.06528 45.3189 7.45839 45.296ZM7.45839 37.0272H53.1817C53.5748 37.0501 53.8891 37.3637 53.912 37.7568V40.1892C53.8891 40.5823 53.5748 40.8959 53.1817 40.9188H7.45839C7.06528 40.8959 6.75094 40.5823 6.72803 40.1892V37.7554C6.75094 37.3623 7.06528 37.0486 7.45839 37.0257V37.0272ZM7.45839 27.7845H17.9168C18.3099 27.8075 18.6236 28.1218 18.6465 28.5149V30.9451C18.6236 31.3382 18.3099 31.6526 17.9168 31.6755H7.45839C7.06528 31.6526 6.75094 31.3382 6.72803 30.9451V28.5135C6.75094 28.1204 7.06528 27.8075 7.45839 27.7845Z",
				fill: "#D5DEE7"
			})
		]
	})
});
export default SvgDocument;
